module.exports = __webpack_public_path__ + "img/default-image.703fa5ea.png";